import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { ArrowRight } from 'lucide-react';
import PageHeader from '../components/PageHeader';
import ServiceIcon from '../components/ServiceIcon';
import useSEO from '../hooks/useSEO';
import useJsonLd from '../hooks/useJsonLd';
import { PAGE_SEO, SITE_CONFIG } from '../data/seoConfig';
import { INDUSTRIES } from '../mock';

export default function IndustriesList() {
  useSEO(PAGE_SEO.industries);

  useJsonLd('industries-breadcrumb', {
    '@context': 'https://schema.org',
    '@type': 'BreadcrumbList',
    itemListElement: [
      { '@type': 'ListItem', position: 1, name: 'Home', item: SITE_CONFIG.url },
      { '@type': 'ListItem', position: 2, name: 'Industries', item: `${SITE_CONFIG.url}/industries` },
    ],
  });

  return (
    <div>
      <PageHeader
        eyebrow='Industries'
        title={<><span className='text-white'>Digital marketing playbooks tuned for</span> <span className='text-brand-gradient'>your category</span></>}
        description='Category-specific benchmarks, creative libraries, and channel strategies for ecommerce, SaaS, healthcare, real estate, finance, and 12+ industries.'
        crumbs={[{ label: 'Industries' }]}
      />
      <section className='py-20'>
        <motion.div
          className='max-w-7xl mx-auto px-6 grid sm:grid-cols-2 lg:grid-cols-3 gap-5'
          initial='hidden'
          whileInView='show'
          viewport={{ once: true, margin: '-80px' }}
          variants={{
            hidden: {},
            show: { transition: { staggerChildren: 0.06 } },
          }}
        >
          {INDUSTRIES.map((ind) => (
            <motion.div
              key={ind.slug}
              variants={{
                hidden: { opacity: 0, y: 20 },
                show: { opacity: 1, y: 0, transition: { duration: 0.5, ease: [0.2, 0.7, 0.2, 1] } },
              }}
            >
              <Link to={`/industries/${ind.slug}`} className='glass-card rounded-2xl p-6 group block h-full transition-transform duration-500 hover:-translate-y-1'>
                <div className='w-12 h-12 rounded-xl bg-gradient-to-br from-violet-500/20 to-fuchsia-500/10 border border-violet-500/25 flex items-center justify-center text-violet-200'>
                  <ServiceIcon name={ind.icon} className='w-5 h-5'/>
                </div>
                <h3 className='mt-5 font-heading text-[19px] font-semibold text-white'>{ind.title}</h3>
                <p className='mt-2 text-[14px] text-white/60 leading-relaxed'>{ind.blurb}</p>
                <div className='mt-4 inline-flex items-center gap-1.5 text-violet-300 text-[13px] font-medium group-hover:gap-2.5 transition-all'>
                  Explore <ArrowRight className='w-3.5 h-3.5'/>
                </div>
              </Link>
            </motion.div>
          ))}
        </motion.div>
      </section>
    </div>
  );
}
